<template>
  <div class="text">
    <span v-if="isMarkdown" v-html="md.render(cleanedText)"></span>
    <span v-else class="plain-text" v-html="plainText"></span>
  </div>
</template>

<script>
import markdownit from 'markdown-it'
export default {
  name: "ChatMessageText",
  props: {
    message: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      md: markdownit(),
    }
  },
  computed: {
    messageText() {
      return this.message.text.replaceAll(/"(.*?)"/g, "$1").replaceAll(/\\n/g, "\n")
    },
    isMarkdown() {
      // Check if text is wrapped in markdown code blocks
      const trimmed = this.messageText.trim()
      return trimmed.startsWith('```markdown') && trimmed.endsWith('```')
    },
    cleanedText() {
      let text = this.messageText
      
      // If wrapped in markdown code blocks, strip them
      if (this.isMarkdown) {
        // Remove ```markdown\n at the start and ``` at the end
        text = text.trim()
        text = text.replace(/^```markdown\s*\n?/, '')
        text = text.replace(/\n?```\s*$/, '')
      }
      
      return text
    },
    plainText() {
      // For plain text, preserve line breaks and escape HTML
      let text = this.messageText
      
      // Escape HTML entities
      text = text.replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;')
      
      // Convert newlines to <br> for display
      text = text.replace(/\n/g, '<br>')
      
      return text
    }
  }
}
</script>


<style>
.text {
  ul {
    padding: 20px;
  }
  
  .plain-text {
    white-space: pre-wrap;
    word-wrap: break-word;
  }
}

</style>